import React, { useState } from "react";
import Layout from "../../Layout";
import {
  Head,
  IframeContainer,
  AnimationContainer,
} from "./styled.component";
import { getToken } from "../../actions/report";
import { useSelector, useDispatch } from "react-redux";
import { configApp } from "utils";

import Iframe from "react-iframe"
import LottieLoader from "react-lottie-loader";
import { ReporteInfo } from "Interfaces/IParameters";
import { useLocation, useParams } from "react-router-dom";
interface Size {
  width: number | undefined;
  height: number | undefined;
}

// Hook
function useWindowSize(): Size {
  const [windowSize, setWindowSize] = React.useState<Size>({
    width: undefined,
    height: undefined,
  });

  React.useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}

interface Orientation {
  orientation: number | undefined;
}

// Hook
function useOrientation(): Orientation {
  const [orientation, setOrientation] = React.useState<Orientation>({
    orientation: undefined,
  });

  React.useEffect(() => {
    // Handler to call on window resize
    let orientationEvent: string =
      "onorientationchange" in window ? "orientationchange" : "resize";

    function handleOrientation() {
      // Set window width/height to state
      setOrientation({
        orientation: window.orientation,
      });
    }
    // Add event listener
    // Listen for orientation changes
    window.addEventListener(orientationEvent, handleOrientation);

    // Call handler right away so state gets updated with initial window size
    handleOrientation();
    // Remove event listener on cleanup
    return () =>
      window.removeEventListener(orientationEvent, handleOrientation);
  }, []); // Empty array ensures that effect is only run on mount
  return orientation;
}

const RNotificacion = () => {
  const { search } = useLocation();

  //@ts-ignore
  const [type, setType] = useState("");
  const [info, setInfo] = React.useState<ReporteInfo | null>();
  const [complementoUrl, setComplementoUrl] = React.useState<string>("");
  const [isLoading, setIsLoading] = React.useState<number>(0);
  const { bannerCatalog, background } = useSelector(
    (state: any) => state.theme
  );
  const { token_bi } = useSelector((state: any) => state.common);
  const [filterValues, setFilterValues] = React.useState<any>({});
  const [viewMode, setViewMode] = React.useState<string>("Normal");

  //const de animaciones
  const data = require("../../data/77440-graph-diagram-animation.json");
  const loader = require("../../data/loader_animation.json");

  const dispatch = useDispatch();

  //Hooks de apoyo para medidas y orientación
  const size: Size = useWindowSize();
  const orientation: Orientation = useOrientation();

  React.useEffect(() => {
    let data = search.replace("?RptCode=", "");
    let strParameters = atob(data);
    if (strParameters.indexOf("TypeReport") > -1) {
      let parametes = strParameters.split("&");
      let strSendParametros = "";
      let reportId = "";
      parametes.forEach((item, index) => {
        if (item.indexOf("reportId") > -1) {
          reportId += item.split("=")[1];
        } else if (
          item.indexOf("TypeReport") < 0 &&
          item.indexOf("reportId") < 0
        ) {
          strSendParametros += `${item.replace("in(", "in (")} and `;
        }
      });
      strSendParametros = strSendParametros.substring(
        0,
        strSendParametros.length - 4
      );
      setInfo({
        report_id: reportId,
        parameters: [],
        url:
          "https://app.powerbi.com/reportEmbed",
        name: "",
        parent: "",
      });
      setComplementoUrl(strSendParametros);
      setType("POWERBI");
    } else {
      setComplementoUrl(strParameters);
      setType("SSRS");
      setIsLoading(3);
    }
  }, [search]);

  /*ESTATUS LOADER */
  /*
 1 Cargando filtros
 2 Filtros cargados
 3 Render reporte
 4 Error
  */

  React.useEffect(() => {
    //is MobileLandscape
    if (orientation.orientation && orientation.orientation === 90) {
      setViewMode("MobileLandscape");
      return;
    }

    //is Mobile
    if (size.width && size.width < 800 && orientation.orientation === 0) {
      setViewMode("MobilePortrait");
      return;
    }

    //is normal
    if (size.width && size.width > 800 && orientation.orientation === 0) {
      setViewMode("Normal");
      return;
    }
    return () => { };
  }, [orientation, size]);

  React.useEffect(() => {
    if (isLoading == 2) {
      const timer = setTimeout(() => setIsLoading(3), 4000);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);


  React.useEffect(() => {
    if (info?.report_id !== undefined) {
      let urlFull = `${configApp.url_powerBi}powerBI.aspx?urlEmbedUrl=${info?.url}&reportId=${info?.report_id}&viewMode=${viewMode}&parametersPowerBi=${complementoUrl}`;
      //@ts-ignore
      setInfo({ ...info, "urlFull": urlFull });
      setIsLoading(3);
    }
  }, [info?.report_id, viewMode])


  React.useEffect(() => {
    //@ts-ignore
    if (type.toUpperCase() === "POWERBI") {
      getToken().then((res: any) => {
        if (!res || !res.access_token) return null;
        dispatch({ type: "token_power", payload: res.access_token });
      });
    }
  }, [type]);

  return (
    <Layout
      hiddenBar={true}
      theme={{
        backgroundColor: "#f5f7f7",
      }}
    >
      <>
        <Head bg={bannerCatalog}>
          {[1, 2, 3].includes(isLoading) && (
            <span className="title-report">
              Reporteador Business Intelligence
            </span>
          )}
        </Head>
        {isLoading === 2 && (
          <AnimationContainer>
            <LottieLoader animationData={data} className={"animation"} />
          </AnimationContainer>
        )}
        {isLoading === 0 && (
          <AnimationContainer>
            <LottieLoader animationData={loader} className={"animation"} />
          </AnimationContainer>
        )}
        {type.toUpperCase() === "SSRS" && complementoUrl.length > 0 && (
          <IframeContainer
            src={`${configApp.url_reporte}?${complementoUrl}`}
            display={isLoading === 3 ? "flex" : "none"}
          />
        )}
        {type.toUpperCase() === "POWERBI" &&
          info?.urlFull &&
          isLoading === 3 && (
            <Iframe
              id="IdFrame"
              url={info?.urlFull}
              position="absolute"
              width={`100%`}
              height={`94%`}
              frameBorder={0}
            />
          )}
      </>
    </Layout>
  );
};

export default RNotificacion;
